<template>
  <div :class="`${NAME_PRE}-flaw-group`">
    <ul :class="`${NAME_PRE}-flaw`">
      <li
        v-for="type in flawType "
        :key="type.flawId"
      >
        <span
          :class="[...flawLabelClass, getActive(type.flawId)]"
          @click="checkFlaw(type)"
        >{{type.flawName}}</span>
        <span
          v-if="inputShow(type.flawId) && type.isInput"
          :class="`${NAME_PRE}-flaw__input`"
          style="width:35px;"
        >
          <hc-input
            border="bottom"
            :size="size"
            placeholder=""
            v-model="type.flawTimes"
          ></hc-input>
        </span>
      </li>
      <li>
        <slot name="flawDesc"></slot>
      </li>
    </ul>
  </div>
</template>
<script>
import { NAME_PRE } from '@/packages/constant/index';
import { FLAW_TYPES } from './type.js';

export default {
  name: `${NAME_PRE}-flaw`,

  model: {
    prop: 'defaultActive',
    event: 'checked',
  },

  props: {
    size: {
      type: String,
      default: '',
    },

    flawType: {
      type: Array,
      default: () => {
        return FLAW_TYPES;
      },
    },

    defaultActive: {
      type: Array,
      default: () => [],
    },

    // 需要展示input的瑕疵Id
    inputData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      NAME_PRE,
      // inputShowData: this.inputData,
    };
  },

  computed: {
    flawLabelClass() {
      let flawClasses = [`${NAME_PRE}-flaw__label`];
      if (this.size) {
        flawClasses.push(`${NAME_PRE}-flaw__label--${this.size}`);
      }
      return flawClasses;
    },
  },

  mounted() {
    console.log(999, this['_events']);
  },

  methods: {
    getActive(id) {
      let flag = this.defaultActive.includes(id);
      return flag ? 'is-active' : '';
    },

    checkFlaw(row) {
      let id = row.flawId;
      let arr = [...this.defaultActive];
      let index = arr.findIndex((e) => {
        return e === id;
      });

      // 如果id为无瑕疵
      if (id === 0) {
        // 存在已激活的，则删除
        if (index > -1) {
          arr.splice(index, 1);
        } else {
          // 把所有的瑕疵的input全隐藏
          this.flawType.forEach((e) => {
            e.isInput = false;
          });
          arr = [id]; // 则保留这一个
        }
      } else {
        if (index > -1) {
          arr.splice(index, 1);
          row.isInput = false;
        } else {
          arr.push(id);
          arr = arr.filter((e) => {
            return e !== 0;
          });
          row.isInput = true;
        }
      }

      this.$emit('checked', arr);

      let tArr = this.flawType.filter((e) => {
        return arr.includes(e.flawId);
      });
      this.emitMethods('change', tArr);
    },

    inputShow(id) {
      return this.inputData.includes(id);
    },

    emitMethods(methodName, params) {
      let events = this['_events'];
      if (events[methodName]) {
        events[methodName].forEach(() => {
          this.$emit(methodName, params);
        });
      }
    },
  },
};
</script>